// extracted by mini-css-extract-plugin
export default {"queryButton":"_9A4KH _38618 _3Dqep qXm3b _20SLo _2XN97","queryButtonText":"HwsY- _2kZNz _1Wqf2"};